



















import Vue from 'vue';
import Component, { mixins } from 'vue-class-component';
import ChildComponentMixin from '@/common/ts/child-component/ChildComponentMixin';
import TrackingPushService from '@/common/ts/tracking/TrackingPushService';

export interface FooterSitemapLinkInterface {
  text: string;
  url: string;
  target: string;
}

const FooterSitemapItemProps = Vue.extend({
  props: {
    listHeadline: String,
    listJson: String,
    editMode: Boolean,
    pageOpenedInEditMode: Boolean,
  },
});
@Component
export default class FooterSitemapItem extends mixins(FooterSitemapItemProps, ChildComponentMixin) {
  index = 0;
  fadeIn = false;

  created () {
    this.initChildComponentMixin(
      'FooterSitemapItem',
    );
  }

  // for experience fragment in aem: edit-mode is not active for the component in the experience
  // fragment but we are currently still in the author view and have to apply the same behaviour
  // as for edit-mode
  get editModeOrPageOpenedInEditMode (): boolean {
    return this.editMode || this.pageOpenedInEditMode;
  }

  get rootClass () {
    return {
      'brandhub-footer-sitemap-item--in': this.fadeIn,
      'brandhub-footer-sitemap-item--edit-mode': this.editModeOrPageOpenedInEditMode,
    };
  }

  get linkList (): Array<FooterSitemapLinkInterface> {
    const json = JSON.parse(this.listJson);
    if (json) {
      return json.links;
    }
    return [];
  }

  hasLink (item: FooterSitemapLinkInterface) {
    return !!(item.url);
  }

  onItemClick (item: FooterSitemapLinkInterface): void {
    if (this.hasLink(item)) {
      const link = item.url;
      const label = item.text;
      TrackingPushService.getInstance().pushTrackingAttributes('link', 'Footer Sitemap', label, link);
    }
  }

  onFocusIn () {
    this.$el.dispatchEvent(new CustomEvent(
      'footerSitemapItemFocused',
      {
        bubbles: true,
        composed: true,
        detail: {
          item: this,
        },
      },
    ));
  }
}
